<app-admin-page-model routeName="Événements" pageTitle="Gestion des événements">

  <app-create-event-action [categories]="categories | async"
                           (eventChange)="createEvent($event)"
                           [event]="toEdit"></app-create-event-action>
  <div class="mt-4">
    <app-list-events [events]="$events" (edit)="editEvent($event)" (remove)="askToRemove($event)"></app-list-events>
  </div>

  <app-dynamic-modal-form
    title="Suppression de l'événement"
    [actions]="[{label: 'Supprimer', class: 'btn-danger', icon: 'trash-alt'}]"
    [object]="toRemove"
    (onSubmit)="remove()">
    <ng-template let-object="object">
      Êtes-vous sûr de vouloir supprimer le l'événement {{ object.title }} ?
    </ng-template>
  </app-dynamic-modal-form>

</app-admin-page-model>
